import { signal, WritableSignal } from '@angular/core';
import { APPEND_BUTTON_PASSWORD_STATE } from '@common/constants';

export enum PasswordTypeKey {
  Base = 'password',
  Old = 'oldPassword',
  New = 'newPassword',
  Confirm = 'confirmPassword'
}

export const normalizeWhitespace = (str: string): string => {
  return str.replace(/\s+/g, ' ');
};

export const getAppendButtonsIcon = (value: string): string => {
  return normalizeWhitespace(value) === APPEND_BUTTON_PASSWORD_STATE.hidden.type
    ? APPEND_BUTTON_PASSWORD_STATE.hidden.icon
    : APPEND_BUTTON_PASSWORD_STATE.visible.icon;
};
export const getAppendButtonsState = (condition) => (condition ? 'visible' : 'hidden');
export const hasAppendButtonsPasswordType = (value) => normalizeWhitespace(value) === APPEND_BUTTON_PASSWORD_STATE.hidden.type;

export const togglePasswordType = (type: string) => {
  const isPasswordType = hasAppendButtonsPasswordType(type);

  return APPEND_BUTTON_PASSWORD_STATE[getAppendButtonsState(isPasswordType)].type;
};

export const createAppendButtonId = (id: string) => `append-${id}`;

export const passwordTypeFactory = (keys): Record<string, WritableSignal<string>> => {
  return Object.fromEntries(Object.values(keys).map((key) => [key, signal<string>(APPEND_BUTTON_PASSWORD_STATE.hidden.type)]));
};
